
import {throwError, Observable } from 'rxjs';

import {catchError, map} from 'rxjs/operators';

import { LocaleService } from '../ui/locale.service';
import { Injectable } from '@angular/core';
import { SettingsService } from './settings.service';
import { StaticsService } from "./statics.service";

import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import {ModalService} from "../ui/modal.service";



@Injectable()
export class WsService {

	constructor(private settingsService: SettingsService, private http: HttpClient,
		private localeService: LocaleService,
		private modalService: ModalService,
		private staticsService: StaticsService) {}

	public execPublicFile(filename): Observable<any> {
		return this.http.get(filename).pipe(
			catchError(this.handleError));
	}
	/**
	 * Execute a REST call.
	 *
	 * @param serviceCall - string indicate name of REST service
	 * @param query - json object to pass on the REST call
	 * @param replacer - optional string array of object and field names on the query object. if provided
	 * only these values will be sent on the request.
	 */
	public executeWS(serviceCall:string = "", query:Map<string,string>, replacer?: string[]): Observable<any> {
		let httpParams: HttpParams  = new HttpParams()

		query.forEach((value: string, key: string) => {
			if (value.length == 0) {
				httpParams = httpParams.set(key , " ");
			}
			else {
				httpParams = httpParams.set(key , decodeURI(value));
			}
		});

		const options = { params: httpParams };

		return this.http.get( this.settingsService.getServiceBaseUrl()+serviceCall + this.settingsService.getServiceAwsParser(), options).pipe(
			map(res => this.extractServerData(res, this)),
			catchError((error:any) => this.serverError(error, null)),);
	}

	private serverError(error: Error | any, jsonRequest: string | null): any {

		this.modalService.hideProcessingModal();
		this.modalService.showErrorModal();
		if(error instanceof Error) {
			error.message = error.message + '<jsonRequest>' + jsonRequest + '</jsonRequest>';
			throw error;
		} else {
			throw new Error('ServiceMan Call Error: at ' + error +
				'<jsonRequest>' + jsonRequest + '</jsonRequest>');
		}
	}
	private extractServerData(body, _this) {
		// handle system error
		/**
		const validationErrorFree: boolean = _this.systemErrorService.handleServiceManResponse(body);
		if (validationErrorFree) {
			return body || {};
		} else {
			return null;
		}
		 **/
		return body || {};
	}
	private handleError(error: any) {
		const errMsg = (error.message) ? error.message :
			error.status ? `${error.status} - ${error.statusText}` : 'Server error';
		return throwError(() => new Error(errMsg));
	}
}
